import type { IconDefinition } from '../../types'

export default {
  details: [32, 32, [], '', 'M32 15.9804C32 16.7315 31.4994 17.4825 30.7486 17.7955L2.77995 29.8748C2.52967 30 2.27939 30 2.02912 30C1.46599 30 0.902861 29.8122 0.527443 29.3741C-0.0356848 28.8108 -0.160824 27.872 0.214594 27.121L4.84475 17.9207L19.9866 16.043L4.84475 14.1028L0.214594 4.9025C-0.160824 4.15145 -0.0356848 3.21264 0.527443 2.64936C1.09057 2.02348 2.02912 1.83572 2.77995 2.14866L30.8112 14.1654C31.562 14.4784 32 15.2294 32 15.9804Z'],
  name: 'uiPaperPlaneTopSolid'
} as IconDefinition
